// FORCE UPDATE SCREEN
//
// Rendered by AppComponent when RemoteConfig detects the native app version is
// too old. NOT a routed page — rendered directly inside <ion-app>.
//
// Does NOT use <ion-content> because that component requires a routed-page
// context (ion-router-outlet parent) to calculate height correctly. Without it,
// ion-content renders at 0 height and shows a blank white screen.
// A plain fixed-position div is used instead.

import { Component, Input } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { downloadOutline } from 'ionicons/icons';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'app-force-update',
  standalone: true,
  imports: [IonButton, IonIcon],
  template: `
    <div class="overlay">
      <div class="card">
        <div class="icon-wrap">
          <ion-icon name="download-outline" class="update-icon"></ion-icon>
        </div>
        <h1>Update Required</h1>
        <p class="message">{{ message }}</p>
        <ion-button expand="block" (click)="openStore()" class="update-btn">
          <ion-icon name="download-outline" slot="start"></ion-icon>
          Update Now
        </ion-button>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
    .overlay {
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      z-index: 9999;
      background: var(--ion-background-color, #ffffff);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 32px;
    }
    .card {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      max-width: 360px;
      width: 100%;
    }
    .icon-wrap {
      width: 80px; height: 80px; border-radius: 50%;
      background: var(--ion-color-primary);
      display: flex; align-items: center; justify-content: center;
      margin-bottom: 24px;
    }
    .update-icon { font-size: 40px; color: white; }
    h1 { font-size: 1.5rem; font-weight: 700; margin: 0 0 12px; }
    .message {
      font-size: 1rem;
      color: var(--ion-color-medium);
      line-height: 1.5;
      margin: 0 0 32px;
    }
    .update-btn { max-width: 280px; width: 100%; }
  `]
})
export class ForceUpdateComponent {
  @Input() message = 'A new version is required to continue using this app.';
  @Input() storeUrl = '';

  constructor() {
    addIcons({ downloadOutline });
  }

  async openStore() {
    if (this.storeUrl) {
      await Browser.open({ url: this.storeUrl });
    }
  }
}
